export const isToggleFeatureEnabled = feature => {
  return !!(
    feature &&
    window.axa &&
    window.axa.features &&
    window.axa.features[feature] &&
    (window.axa.features[feature] === "true" ||
      window.axa.features[feature] === true)
  );
};

export const ToggleFeature = ({ children, feature }) => {
  if (isToggleFeatureEnabled(feature)) {
    return children;
  }
  return null;
};

export default ToggleFeature;
